import { useAction, useAtom } from '@reatom/npm-react'

import { WalletsTable } from '@root/features/portfolio/wallets-table/ui/wallets-table'

import { walletsManagerModelAtom } from '../../atoms'

type Props = {}

export const PortfolioWalletsTable: React.FC<Props> = () => {
  const [model] = useAtom(walletsManagerModelAtom)
  const openEditWallet = useAction(model.openEditWallet)
  const setTransactionsWallet = useAction(model.setTransactionsWallet)
  const [selectedWalletIds] = useAtom(model.selectedWalletIds)
  const toggleSelectedWallet = useAction(model.toggleSelectedWallet)
  const selectSingleWallet = useAction(model.selectSingleWallet)

  return (
    <WalletsTable
      onEditClick={openEditWallet}
      onTransactionsClick={setTransactionsWallet}
      selectedWalletIds={selectedWalletIds}
      onToggleSelection={toggleSelectedWallet}
      onSelectSingleWallet={selectSingleWallet}
    />
  )
}
